// import { display } from "html2canvas/dist/types/css/property-descriptors/display";
import React, { useState, useRef } from "react";

const FunWebPage = () => {
  const [background, setBackground] = useState("#f9f9f9");
  const [pageTitle, setPageTitle] = useState("");
  const [images, setImages] = useState([]);
  const funSoundRef = useRef(null);
  const clickSoundRef = useRef(null);
  const rainbowIntervalRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const newImg = { src: event.target.result, id: Date.now() };
        setImages((prev) => [...prev, newImg]);
      };
      reader.readAsDataURL(file);
    }
  };

  const resetAll = () => {
    setBackground("#f9f9f9");
    setPageTitle("");
    setImages([]);
    if (rainbowIntervalRef.current) clearInterval(rainbowIntervalRef.current);
  };

  const playSound = () => {
    funSoundRef.current.play();
  };

  const rainbowMode = () => {
    const colors = ["#ff99cc", "#ffcc00", "#66ff66", "#66ccff", "#cc99ff"];
    let i = 0;
    if (rainbowIntervalRef.current) clearInterval(rainbowIntervalRef.current);
    rainbowIntervalRef.current = setInterval(() => {
      setBackground(colors[i]);
      i = (i + 1) % colors.length;
    }, 800);
  };

  const downloadPage = () => {
    const element = document.createElement("a");
    const htmlContent = document.documentElement.outerHTML;
    const file = new Blob([htmlContent], { type: "text/html" });
    element.href = URL.createObjectURL(file);
    element.download = "MyFunWebPage.html";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const makeDraggable = (e) => {
    const el = e.target;
    el.style.position = "absolute";
    el.style.zIndex = 1000;

    const moveAt = (pageX, pageY) => {
      el.style.left = pageX - el.offsetWidth / 2 + "px";
      el.style.top = pageY - el.offsetHeight / 2 + "px";
    };

    const onMouseMove = (event) => moveAt(event.pageX, event.pageY);

    document.addEventListener("mousemove", onMouseMove);

    el.onmouseup = () => {
      document.removeEventListener("mousemove", onMouseMove);
      el.onmouseup = null;
    };
  };

  // Inline styles
  const styles = {
    body: {
      textAlign: "center",
      fontFamily: "'Comic Sans MS', cursive",
      background: background,
      overflowX: "hidden",
      transition: "background 0.5s",
      minHeight: "100vh",
      padding: "20px",
    },
    h1: {
      fontSize: "2rem",
      color: "#ff3399",
      marginBottom: "20px",
      animation: "bounce 2s infinite",
    },
    section: {
      margin: "15px auto",
      maxWidth: "600px",
      
    },
    button: {
      margin: "6px",
      padding: "8px 14px",
      border: "none",
      borderRadius: "10px",
      background: "linear-gradient(135deg, #ffcc00, #ff9900)",
      color: "#fff",
      fontSize: "14px",
      fontWeight: "bold",
      cursor: "pointer",
      boxShadow: "0 3px 5px rgba(0,0,0,0.2)",
      transition: "all 0.2s ease",
    },
    inputText: {
      padding: "6px 10px",
      borderRadius: "6px",
      border: "2px solid #ff99cc",
      fontSize: "14px",
      width: "80%",
      maxWidth: "300px",
      marginBottom: "10px",
       display: "block",
    },
    imgBox: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      marginTop: "10px",
    },
    img: {
      maxWidth: "200px",
      margin: "6px",
      transition: "transform 0.3s",
      cursor: "grab",
      borderRadius: "8px",
      boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
    },
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>🌟 Super Fun Web Page 🌟</h1>

      {/* Background Color */}
      <div style={styles.section}>
        <label>🎨 Pick a background color:</label>
        <div  style={{ display: "flex", justifyContent: "center" }}  >
        <input
          type="color"
          onChange={(e) => setBackground(e.target.value)}
          style={{ margin: "6px", padding: "4px", cursor: "pointer" , width:"20%", justifyContent: "center"}}
        /></div>
        <button
          style={styles.button}
          onClick={() => {
            rainbowMode();
            clickSoundRef.current.play();
          }}
        >
          🌈 Rainbow Mode
        </button>
      </div>

      {/* Title */}
      <div  style={{ display: "flex", justifyContent: "center" }} >
        <input
          type="text"
          value={pageTitle}
          placeholder="Type Page Title..."
          onChange={(e) => setPageTitle(e.target.value)}
          style={styles.inputText}
        />
        <h2 style={{ fontSize: "1.2rem", color: "#333" }}>{pageTitle}</h2>
      </div>

      {/* Picture Upload */}
      <div style={styles.section}>
        <div style={{ display:"flex",justifyContent: "center"}}  >
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            handleFileChange(e);
            clickSoundRef.current.play();
          }}
          style={{ margin: "6px", padding: "8px 12px", borderRadius: "10px" }}
        /></div>
        <button
          style={styles.button}
          onClick={() => {
            resetAll();
            clickSoundRef.current.play();
          }}
        >
          ♻️ Reset
        </button>
        <div style={styles.imgBox}>
          {images.map((img) => (
            <img
              key={img.id}
              src={img.src}
              style={styles.img}
              onMouseDown={makeDraggable}
            />
          ))}
        </div>
      </div>

      {/* Fun & Download */}
      <div style={styles.section}>
        
        <button
          style={styles.button}
          onClick={() => {
            downloadPage();
            clickSoundRef.current.play();
          }}
        >
          💾 Download My Webpage
        </button>
      </div>

      {/* Sounds */}
      <audio ref={funSoundRef} src="https://www.soundjay.com/button/beep-07.wav" />
      <audio ref={clickSoundRef} src="https://www.soundjay.com/button/button-16.mp3" />

      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          img:active { cursor: grabbing; }
          img:hover { transform: rotate(8deg) scale(1.05); }
          @media (max-width: 600px) {
            img { max-width: 70px; }
            button { font-size: 12px; padding: 6px 10px; }
            input[type="text"] { width: 90%; font-size: 13px; }
          }
        `}
      </style>
    </div>
  );
};

export default FunWebPage;
